var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.78557 3.42871H1.857C1.42368 3.42871 1.07129 3.7811 1.07129 4.21443V8.143C1.07129 8.57632 1.42368 8.92871 1.857 8.92871H5.78557C6.2189 8.92871 6.57129 8.57632 6.57129 8.143V4.21443C6.57129 3.7811 6.2189 3.42871 5.78557 3.42871Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.143 1.07129H4.21443C4.00604 1.07129 3.80619 1.15407 3.65884 1.30142C3.51149 1.44877 3.42871 1.64862 3.42871 1.857V2.64272H6.57157C6.77995 2.64272 6.9798 2.7255 7.12715 2.87285C7.2745 3.0202 7.35728 3.22005 7.35728 3.42843V6.57129H8.143C8.35138 6.57129 8.55123 6.48851 8.69858 6.34116C8.84593 6.19381 8.92871 5.99396 8.92871 5.78557V1.857C8.92871 1.64862 8.84593 1.44877 8.69858 1.30142C8.55123 1.15407 8.35138 1.07129 8.143 1.07129Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.1ef307fa25e5817e93add5ab67abe124.svg";
export { ForwardRef as ReactComponent };